document.addEventListener('DOMContentLoaded', () => {
  const slidesContainer = document.querySelector('.feature-slider .slides');
  const slides = slidesContainer.querySelectorAll('.slide');
  const prev = document.querySelector('.slide-prev');
  const next = document.querySelector('.slide-next');
  const dotsContainer = document.querySelector('.slider-dots .slider-dots-wrapper');
  let current = 0;

  if (!slides.length) return;

  // Create dots
  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    if (i === 0) dot.classList.add('active');
    dotsContainer.appendChild(dot);
    dot.addEventListener('click', () => showSlide(i));
  });

  const dots = dotsContainer.querySelectorAll('span');

  function showSlide(index) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');

    // Move slides container to show current slide
    slidesContainer.style.transform = `translateX(-${current * 100}%)`;
  }

  prev.addEventListener('click', () => showSlide(current - 1));
  next.addEventListener('click', () => showSlide(current + 1));

  // Start at first slide
  slides[current].classList.add('active');
  slidesContainer.style.transform = `translateX(0)`;


  // Touch swipe support
  let startX = 0;
  let isDragging = false;

  slidesContainer.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }
  });

  slidesContainer.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const diffX = currentX - startX;
    // Optionally prevent scrolling
    if (Math.abs(diffX) > 10) {
      e.preventDefault();
    }
  }, { passive: false });

  slidesContainer.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    const endX = e.changedTouches[0].clientX;
    const diffX = endX - startX;

    if (Math.abs(diffX) > 50) { // swipe threshold in px
      if (diffX > 0) {
        showSlide(current - 1); // swipe right to go back
      } else {
        showSlide(current + 1); // swipe left to go next
      }
    }
    isDragging = false;
  });
   
});
